const config = {
  development: {
    api: 'http://localhost:3002',
    socket: 'http://dev.kambria.io:8080',
  },

  /**
   * !!!WARNING!!!
   * DO NOT CHANGE THE CONFIGURATIONS BELOW. THEY ARE USED BY CI/CD
   */
  staging: {
    api: 'https://staging-api.kambria.io',
    socket: 'https://staging-socket.kambria.io',
  },
  uat: {
    api: 'https://uat-api.kambria.io',
    socket: 'https://uat-socket.kambria.io',
  },
  production: {
    api: 'https://api.kambria.io',
    socket: 'https://socket.kambria.io',
  },
};

export default config;
